import styled from 'styled-components';


export const HelpButtonOverlay = styled.div.attrs(() => ({
  className: 'HelpButtonOverlay'
}))`
  opacity: 0;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9;
`;

export const ButtonContainer = styled.div.attrs(() => ({ className: 'HelpButton' }))`
  display: none;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.shadeMedium};
  border-radius: 50%;
  height: 40px;
  width: 40px;
  margin-right: 40px;
  z-index: 10;

  &:hover {
    cursor: pointer;
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    display: flex;
  }
`;

export const Icon = styled.img.attrs(() => ({ className: 'QuestionMark'}))`
  height: 14.5px;
  width: 9px;
`;

export const WidgetContainer = styled.div.attrs(() => ({ className: 'Widget' }))`
  position: absolute;
  top: 63px;
  right: 80px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.shadeMedium};
  border-radius: 4px;
  overflow-y: scroll;
  overflow-wrap: break-word;
  padding: 15px;

  max-height: 697px;
  width: 287px;
  z-index: 10;
`;

export const Header = styled.h3.attrs(() => ({ className: 'WidgetSectionHeader' }))`
  color: ${({ theme }) => theme.colors.newKinedu};
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 2.5;
  text-transform: uppercase;
  margin: 0;
  margin-bottom: 5px;

  &:not(:first-child){
    margin-top: 20px;
  }
`;

export const WidgetLinkItem = styled.p.attrs(() => ({ className: 'WidgetSectionLinkItem' }))`
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 14px;
  margin: 0;
  margin-bottom: 10px;
`;

export const WidgetLink = styled.span.attrs(() => ({ className: 'WidgetSectionLink' }))`
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 14px;
  text-decoration: none;
  display: block;
  margin: 10px 0;

  &:hover {
    color: ${({ theme }) => theme.colors.newKinedu};
    cursor: pointer;
    text-decoration: underline;
  }
`;
